export const KEYBOARD_CONTEXT_MEDIA = 'media';
export const KEYBOARD_CONTEXT_MEDIA_SLIDER = 'media_slider';
export const KEYBOARD_CONTEXT_POPUP = 'popup';
